import { jsonApi } from './index';

const employmentPeriodsAPI = {
  getAll(params) {
    return jsonApi.request('/api/user/employment-periods',"GET", {}, params);
  },
};

export default employmentPeriodsAPI;
